import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import PropTypes from 'prop-types';
import AuthenticationFactorList from './AuthenticationFactorList';
import AuthenticationFactorListRevamp from './AuthenticationFactorListRevamp';

const AuthenticationFactorListContainer = ({ ListProps, shouldUseUserSettingsRevamp }) => {
  const { isInitializing, loadingError, collection } = useCollectionStateContext();

  let Component = AuthenticationFactorList;
  if (shouldUseUserSettingsRevamp) {
    Component = AuthenticationFactorListRevamp;
  }

  return (
    <DataContainer
      component={Component}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{ ...ListProps, collection }}
    />
  );
};

AuthenticationFactorListContainer.defaultProps = {
  ListProps: {},
  shouldUseUserSettingsRevamp: false,
};

AuthenticationFactorListContainer.propTypes = {
  ListProps: PropTypes.object,
  shouldUseUserSettingsRevamp: PropTypes.bool,
};

export default AuthenticationFactorListContainer;
